import { getFareInitialObj } from "./store";
import { Action, ChartStore, Types } from "./types";

export const reducer = (state: ChartStore, action: Action): ChartStore => {
  const { type, payload } = action;
  switch (type) {
    case Types.SET_CHART_DATA:
      return {
        ...state,
        chartData: payload,
      };

    case Types.SET_SELECTED_SEATS:
      return {
        ...state,
        selectedSeats: payload,
      };
    case Types.SET_LOADING:
      return {
        ...state,
        loading: payload,
      };
    case Types.SET_FARE_BREAKUP:
      return {
        ...state,
        fareBreakup: payload,
      };
    case Types.SET_FARE_BREAKUP:
      return {
        ...state,
        fareBreakup: payload,
      };
    case Types.SET_FARE_BREAKUP:
      return {
        ...state,
        fareBreakup: payload,
      };

    case Types.SET_SELECTED_DROPOFF:
      return {
        ...state,
        selectedDropoff: payload,
      };

    case Types.SET_SELECTED_PICKUP:
      return {
        ...state,
        selectedPickup: payload,
      };

    case Types.SET_LOADING:
      return {
        ...state,
        loading: payload,
      };

    case Types.SET_SHOW_SEAT_LAYOUT:
      return {
        ...state,
        showSeatLayout: payload,
      };
    case Types.CLEAR_CHART_CONTEXT:
      return {
        ...state,
        // chartData: null,
        // showSeatLayout: false,
        errMsg: false,
        selectedSeats: [],
        fareBreakup: {
          fare: getFareInitialObj(0),
          fareCategory: getFareInitialObj(),
          fareLabel: getFareInitialObj(),
          seats: 0,
        },
        selectedPickup: null,
        selectedDropoff: null,
      };
  }
};

// export const reducer = (state: Store, action: Action): Store => {
//   const { type, data } = action;

//   switch (type) {
//     case Types.SET_CHART_DATA:
//       return {
//         ...state,
//         data,
//       };
//     case Types.SEL_INFO:
//       return {
//         ...state,
//         selInfo: data,
//       };
//     case Types.SEL_SEATS:
//       return {
//         ...state,
//         selSeats: data,
//       };
//     case Types.SEL_PICK:
//       return {
//         ...state,
//         selPickup: data,
//       };
//     case Types.SEL_DROP:
//       return {
//         ...state,
//         selDropoff: data,
//       };
//     case Types.LOADER:
//       return {
//         ...state,
//         showLoader: data,
//       };
//     case Types.ERROR:
//       return {
//         ...state,
//         errMsg: data,
//       };
//     default:
//       return state;
//   }
// };
